import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {

  private apiUrl = environment.backendUrlPort;
  constructor(private http: HttpClient) { }

  getLocalStorage() {
    return new HttpHeaders({
        Authorization: 'Bearer ' + JSON.parse(localStorage.getItem('user')).token
      });
  }

  getAllUserNotifications(table: string): Observable<any> {
    let Api:string = this.apiUrl + '/notifications/getAllUserNotifications/' + table;
    return this.http.get<any>(Api, {headers: this.getLocalStorage()});
  }

  getAllNotificationsContacts(table: string): Observable<any> {
    let Api:string = this.apiUrl + '/notifications/getAllNotificationsContacts/' + table;
    return this.http.get<any>(Api, {headers: this.getLocalStorage()});
  }

  getLatestUserNotifications(table: string): Observable<any> {
    let Api:string = this.apiUrl + '/notifications/getLatestUserNotifications/' + table;
    return this.http.get<any>(Api, {headers: this.getLocalStorage()});
  }

  getUnreadUserNotifications(table: string): Observable<any> {
    let Api:string = this.apiUrl + '/notifications/getUnreadUserNotifications/' + table;
    return this.http.get<any>(Api, {headers: this.getLocalStorage()});
  }

  changeNotificationStatus(table: string): Observable<any> {
    let Api:string = this.apiUrl + '/notifications/changeNotificationStatus/' + table;
    return this.http.get<any>(Api, {headers: this.getLocalStorage()});
  }

  changeNotificationContactsConnectedToAccepted(table: string): Observable<any> {
    let Api:string = this.apiUrl + '/notifications/changeNotificationContactsConnectedToAccepted/' + table;
    return this.http.get<any>(Api, {headers: this.getLocalStorage()});
  }

  changeNotificationContactsConnectedToDeclined(table: string): Observable<any> {
    let Api:string = this.apiUrl + '/notifications/changeNotificationContactsConnectedToDeclined/' + table;
    return this.http.get<any>(Api, {headers: this.getLocalStorage()});
  }

  deleteNotification(table: string, senderId: any): Observable<any> {
    let Api:string = this.apiUrl + '/notifications/deleteNotification/' + table;
    return this.http.put<any>(Api, senderId, {headers: this.getLocalStorage()});
  }
}
